module.exports = __webpack_public_path__ + "assets/img/ed7c56f9baa0b8c27db94719eb4743c8.png";